module.exports = __webpack_public_path__ + "static/media/emoticon-emoticons-emotion-expression-face-use-mask-svgrepo-com.f3ddd35b.svg";